module.exports = __webpack_public_path__ + "img/instagram.6df329bd.svg";